export const DisordersTranslationMap = new Map([

    ["ACUTE_STRESS_DISORDER","Acute stress disorder"],
    ["ADDICTION","Addiction"],
    ["ADJUSTMENT_DISORDER","Adjustment disorder"],
    ["AGORAPHOBIA","Agoraphobia"],
    ["ANOREXIA","Anorexia"],
    ["ANTISOCIAL_PERSONALITY_DISORDER","Antisocial"],
    ["ANXIETY_DISORDERS","Anxiety"],
    ["ATTENTION_DEFICIT_HYPERACTIVITY_DISORDER_ADHD","ADHD"],
    ["AUTISM_SPECTRUM_DISORDER","Autism"],
    ["BEREAVEMENT","Bereavement"],
    ["BINGE_EATING_DISORDER","Binge eating"],
    ["BIPOLAR_DISORDER","Bipolar disorder"],
    ["BODY_DYSMORPHIC_DISORDER","Body dysmorphia"],
    ["BORDERLINE_PERSONALITY_DISORDER_BPD","Borderline personality disorder"],
    ["BULIMIA","Bulimia"],
    ["CHRONIC_STRESS","Chronic stress exposure"],
    ["CONVERSION_DISORDER","Conversion disorder"],
    ["CYCLOTHYMIC_DISORDER","Cyclothymic disorder"],
    ["DELUSIONAL_DISORDER","Delusional disorder"],
    ["DEMENTIA_OF_THE_ALZHEIMER_TYPE","Dementia/Alzheimer"],
    ["DEPERSONALIZATION_DISORDER","Depersonalisation disorder"],
    ["DEPRESSION","Depression"],
    ["DISSOCIATIVE_AMNESIA","Dissociative amnesia"],
    ["DISSOCIATIVE_DISORDERS","Dissociative disorders"],
    ["DISSOCIATIVE_IDENTITY_DISORDER_MPD","Identity disorder (MPD)"],
    ["EARLY_PSYCHOSIS_AND_PSYCHOSIS","Early psychosis/Psychosis"],
    ["EATING_DISORDERS","Eating disorders"],
    ["ERECTILE_DISORDER","Erectile disorder"],
    ["EXHIBITIONISTIC_DISORDER","Exhibitionism"],
    ["FAMILY_PROBLEMS","Family problems"],
    ["GENDER_DYSPHORIA","Gender dysphoria"],
    ["HYPERSOMNIA","Hypersomnia"],
    ["HYPOCHONDRIASIS","Hypochondria"],
    ["INSOMNIA","Insomnia"],
    ["INTELLECTUAL_DISABILITY","Intelectuall disability"],
    ["KLEPTOMANIA","Kleptomania"],
    ["LONELINESS","I just feel lonely"],
    ["MAJOR_DEPRESSIVE_DISORDER","Major depressive disorder (MDD)"],
    ["NARCOLEPSY","Narcolepsy"],
    ["NIGHTMARE_DISORDER","Nightmare/Sleep Terrors"],
    ["OBSESSIVE_COMPULSIVE_DISORDER_OCD","Obsessive compulsive disorder (OCD)"],
    ["ORGASMIC_DISORDERS","Orgasmic disorders"],
    ["PANIC_DISORDER","Panic attacks"],
    ["PARANOID_PERSONALITY_DISORDER","Paranoid"],
    ["PATHOLOGICAL_GAMBLING","Gambling addiction"],
    ["POSTTRAUMATIC_STRESS_DISORDER_PTSD","Posttraumatic stress disorder (PTSD)"],
    ["PREMATURE__EJACULATION","Premature ejaculation"],
    ["PROVISIONAL_TIC_DISORDER","Tic disorder"],
    ["PSYCHOTIC_DISORDER","Psychotic disorder"],
    ["PYROMANIA","Pyromania"],
    ["RELATIONSHIP_PROBLEMS","Relationship problems"],
    ["RHYTHM_SLEEP_WAKE_DISORDER","Sleep rythm disturbances"],
    ["SCHIZOAFFECTIVE_DISORDER","Schizoaffective disorder"],
    ["SCHIZOID_PERSONALITY_DISORDER","Schizoid personality disorder"],
    ["SCHIZOPHRENIA","Schizophrenia"],
    ["SCHOOL_PROBLEMS","School problems"],
    ["SEASONAL_AFFECTIVE_DISORDER_SAD","Seasonal affectiveness"],
    ["SELFESTEEM_ISSUE","Low self esteem"],
    ["SELF_INJURY","Self injury"],
    ["SEPARATION_ANXIETY_DISORDER","Separation anxiety"],
    ["SEXUAL_AROUSAL_DISORDER","Sexual arousal disorder"],
    ["SEXUAL_DYSFUNCTION","Sexual dysfunction"],
    ["SHARED_PSYCHOTIC_DISORDER","Shared psychotic disorder"],
    ["SHORT_TERM_MEMORY_LOSS","Short term memory loss"],
    ["SLEEPWALKING_DISORDER","Sleepwalking"],
    ["SOCIAL_ANXIETY","Social anxiety"],
    ["SOMATIC_SYMPTOM_DISORDER","Somatic symptoms"],
    ["STUTTERING","Stuttering"],
    ["SUBSTANCE_ABUSE_AND_MENTAL_ILLNESS","Substance abuse"],
    ["SUICIDAL","Suicidal"],
    ["SURVIVOR_OF_CHILDHOOD_SEXUAL_ABUSE","Childhood abuse"],
    ["SURVIVOR_OF_DOMESTIC_VIOLENCE","Domestic violence"],
    ["SURVIVOR_OF_EMOTIONAL_ABUSE","Emotional abuse"],
    ["SURVIVOR_OF_RAPE","Rape survivor"],
    ["TOURETTE_DISORDER","Tourette disorder"],
    ["TRAUMA","Trauma/Accident survivor"],
    ["TRICHOTILLOMANIA","Trichotillomania"],
    ["VIOLENCE_VICTIM","Violence victim"],
    ["WORK_PROBLEMS","Work problems"]
]);